import axios from "../../../js/project-axios.js";

const list = (appId, name, code) => {
    return axios.get("/servicer/role/list", {
        params: {
            appId,
            name,
            code
        }
    });
};

const add = (appId, role) => {
    return axios.post("/servicer/role/add", role, {
        params: {
            appId
        }
    });
};

const update = role => {
    return axios.post("/servicer/role/update", role);
};

const remove = role => {
    return axios.post("/servicer/role/remove", role);
};

const listPermission = roleId => {
    return axios.get("/servicer/role/listPermission", {
        params: {
            roleId
        }
    });
};

const grantPermission = (roleId, permissionIds) => {
    return axios.post("/servicer/role/grantPermission", permissionIds, {
        params: {
            roleId
        }
    });
};

const listUser = roleId => {
    return axios.get("/servicer/role/listUser", {
        params: {
            roleId
        }
    });
};

const addUser = (roleId, userIds) => {
    return axios.post("/servicer/role/addUser", userIds, {
        params: {
            roleId
        }
    });
};

const removeUser = (roleId, userIds) => {
    return axios.post("/servicer/role/removeUser", userIds, {
        params: {
            roleId
        }
    });
};

export default {
    list,
    add,
    update,
    remove,
    listPermission,
    grantPermission,
    listUser,
    addUser,
    removeUser
};